import { render, staticRenderFns } from "./DeductionsTab.vue?vue&type=template&id=d6e50740"
import script from "./DeductionsTab.vue?vue&type=script&lang=js"
export * from "./DeductionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports